import { client } from "./api";

export const payPublic = (token) => client.get(`/pay/${token}`).then((r) => r.data);
export const payCheckout = (token) => client.post(`/pay/${token}/checkout`, { origin_url: window.location.origin }).then((r) => r.data);
export const payStatus = (token) => client.get(`/pay/${token}/status`).then((r) => r.data);

export const adminPayRequests = (status = "") => client.get("/admin/pay-requests", { params: status ? { status } : {} }).then((r) => r.data.items);
export const adminPayCreate = (payload) => client.post("/admin/pay-requests", payload).then((r) => r.data);
export const adminPayMarkPaid = (id) => client.post(`/admin/pay-requests/${id}/paid`).then((r) => r.data);
export const adminPayRenew = (id) => client.post(`/admin/pay-requests/${id}/renew`).then((r) => r.data);
export const adminPayWaSent = (id) => client.post(`/admin/pay-requests/${id}/wa-sent`).then((r) => r.data);
export const adminPayDelete = (id) => client.delete(`/admin/pay-requests/${id}`).then((r) => r.data);

export const eur = (cents) => `€ ${((cents || 0) / 100).toFixed(2).replace(".", ",")}`;
export const payLink = (token) => `${window.location.origin}/paga/${token}`;
export const PAY_STATUS = {
  pending: ["In attesa", "bg-amber-100 text-amber-900"],
  paid: ["Pagata", "bg-emerald-100 text-emerald-900"],
  expired: ["Scaduta", "bg-stone-200 text-stone-700"],
};
